import cropCategoryReducer from "./cropCategoryReducer";

const cropCategoryReducers = {
    cropCategory: cropCategoryReducer
}

export default cropCategoryReducers;